import { RuleResult } from '../../../types/DeclarationP5'

const NC9043Validator = {
  validateLocationOfGoodsRequirement: ({
    additionalDeclarationType,
  }: {
    additionalDeclarationType: string
  }): RuleResult => (additionalDeclarationType === 'A' ? 'REQUIRED' : 'OPTIONAL'),

}

export default NC9043Validator
